module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/root//pop-coin_info_bg.png?v=543ff742";